<template>
    <c-s-modal
        id="options-modal"
        ref="optionsModal"
        :hide-footer="true"
        :centered="false"
        size="lg"
    >
        <div slot="modal-title">
            Standard Options
        </div>
        <b-tabs>
            <b-tab
                v-for="(options, groupName) in groupedOptions"
                :key="groupName"
                :title="groupName"
            >
                <ul>
                    <li v-for="option in options" :key="option.value">
                        {{ option.value }}
                    </li>
                </ul>
            </b-tab>
        </b-tabs>
    </c-s-modal>
</template>

<script>
import _ from "lodash";
import CSModal from "Components/CSModal/index";

export default {
    components: { CSModal },
    props: {
        trim: {
            type: Object,
            required: true
        }
    },

    computed: {
        groupedOptions() {
            return this.$store.getters["shopBy/groupedOptions"](
                _.get(this, "trim.id")
            );
        }
    },

    methods: {
        show() {
            this.$refs.optionsModal.show();
        }
    }
};
</script>
